import Layout from "@/layout";
export default {
    meta: {
        title: "设置",
        icon: "ali_zggl",
    },
    path: "/TisSetting",
    component: Layout,
    children: [
        {
            path: "/SealSetting/index",
            name: "SealSetting",
            component: () => import("@/views/SealSetting/index"),
            meta: {
                title: "印章设置",
                auth: [],
                img: "fbfx",
            },
        },
    ],
};
